import React, { useState, useEffect } from 'react'
import {
  Table,
  IconButton,
  Icon,
  Panel,
  ButtonGroup,
  Row,
  Col,
  Dropdown,
  SelectPicker,
  Input,
  Button,
  DatePicker,
  CheckPicker,
  Modal,
  ControlLabel,
} from 'rsuite'
import { useHistory } from 'react-router-dom'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { DATE_FORMAT } from '../../constants/date'
import moment from 'moment'
import { budgetFormat } from '../../utils/formatterUtil'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import InputForm from '../../components/forms/input/InputForm'
import { useForm, Controller } from 'react-hook-form/dist/index.ie11'
import { color } from 'echarts'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import { isRequired } from '../../utils/ValidatorUtils'

export default function CheckProjectQualityHistoryList({
  schema,
  loading,
  onSelect = () => {},
  onSearch = () => {},
  onCancel = () => {},
  page = 1,
  displayLength = 5,
  defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ],
  onReload = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const { register, handleSubmit, errors, control, setValue, getValues, clearErrors } = useForm()
  const history = useHistory()
  const [tableData, setTableData] = useState([])
  const [txtProjectCodeVal, SetTxtprojectCodeVal] = useState('')
  const [txtSubProjectCodeVal, SetTxtsubProjectCodeVal] = useState('')

  useEffect(() => {
    setTableData(schema?.data?.values || [])
  }, [schema])
  console.log('schema 5555', schema)

  const handleChangeLength = (dataKey) => {
    onReload(1, dataKey)
  }

  const handleChangePage = (dataKey) => {
    onReload(dataKey, displayLength)
  }

  // console.log('tableData ', tableData)

  return (
    <>
      <Table
        wordWrap
        // height={350}
        // autoHeight={tableData.length < 10}
        minHeight={350}
        autoHeight
        loading={loading}
        data={tableData}
        style={{ marginTop: 10 }}
      >
        <Column width={90} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              // return index + 1
              return (page - 1) * displayLength + index + 1
            }}
          </Cell>
        </Column>

        <Column width={150}>
          <HeaderCell>วันที่</HeaderCell>
          <Cell dataKey="qualityCheckDate" />
        </Column>

        <Column width={150}>
          <HeaderCell>รหัสโครงการหลัก</HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>
        <Column width={150}>
          <HeaderCell>รหัสโครงการย่อย</HeaderCell>
          <Cell dataKey="subProjectCode" />
        </Column>
        <Column width={250}>
          <HeaderCell>ชื่อโครงการย่อย </HeaderCell>
          <Cell dataKey="subProjectName" />
        </Column>
        <Column width={180}>
          <HeaderCell>ระดับคุณภาพโครงการ</HeaderCell>
          <Cell dataKey="projectQualityLevel">
            {(rowData) => {
              const qualityLevel = rowData.projectQualityLevel
              let color, label

              switch (qualityLevel) {
                case 1:
                  color = '#2da888'
                  label = 'ดีมาก'
                  break
                case 2:
                  color = '#ffc489'
                  label = 'ดี'
                  break
                case 3:
                  color = '#fb8a81'
                  label = 'ควรปรับปรุง'
                  break
                default:
                  color = '#5e5e5e'
                  label = 'ไม่มีข้อมูล'
              }

              return (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span
                    style={{
                      color: color,
                      fontSize: '12px',
                      lineHeight: 1,
                    }}
                  >
                    <Icon icon="circle" />
                  </span>
                  <span>{label}</span>
                </div>
              )
            }}
          </Cell>
        </Column>

        <Column width={180}>
          <HeaderCell>ระดับคุณภาพพี่เลี้ยง</HeaderCell>
          <Cell dataKey="nannyQualityLevel">
            {(rowData) => {
              const qualityLevel = rowData.nannyQualityLevel
              let color, label

              switch (qualityLevel) {
                case 1:
                  color = '#2da888'
                  label = 'ดีมาก'
                  break
                case 2:
                  color = '#ffc489'
                  label = 'ดี'
                  break
                case 3:
                  color = '#fb8a81'
                  label = 'ควรปรับปรุง'
                  break
                default:
                  color = '#5e5e5e'
                  label = 'ไม่มีข้อมูล'
              }

              return (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span
                    style={{
                      color: color,
                      fontSize: '12px',
                      lineHeight: 1,
                    }}
                  >
                    <Icon icon="circle" />
                  </span>
                  <span>{label}</span>
                </div>
              )
            }}
          </Cell>
        </Column>

        <Column width={200}>
          <HeaderCell>ผู้ให้ความเห็น</HeaderCell>
          <Cell dataKey="commentator" />
        </Column>

        <Column width={250}>
          <HeaderCell>ความเห็นต่อโครงการ</HeaderCell>
          <Cell dataKey="latestProjectComments" />
        </Column>
      </Table>
      <TablePagination
        lengthMenu={defaultLengthMenu}
        activePage={page}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total} รายการ`}</>
        }}
        displayLength={displayLength || 5}
        total={schema?.data?.totalSize || 0}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />

    </>
  )
}
